module.exports = __webpack_public_path__ + "img/flat-space-background.08a7153a.jpg";